export default __webpack_public_path__ + "static/media/marcela-mate-title.4239a506.png";